export default {
  type: "图例类型",
  show: "是否显示图例",
  left: "图例离左侧距离",
  top: "图例离上侧距离",
  right: "图例离右侧距离",
  bottom: "图例离下侧距离",
  width: "图例宽度",
  height: "图例高度",
  orient: "图例布局朝向",
  align: "图例文本对齐",
  padding: "图例内边距",
  itemGap: "图例每项间间隔",
  itemWidth: "图例图形宽度",
  itemHeight: "图例图形高度",
  data: "图例数据",
  icon: "图例icon"
}
